export type TFileLeftTab = 'original' | 'en' | 'ru' | 'ar' | 'es'

interface IGetNextFileTabsParams {
	leftTab: TFileLeftTab
	rightTab: string | null
	translationLanguages: string[]
	isTranslateLoading: boolean
	lastTranslateTargetLang?: string
}

interface IFileTabsState {
	leftTab: TFileLeftTab
	rightTab: string | null
}

export const getNextFileTabs = ({
	leftTab,
	rightTab,
	translationLanguages,
	isTranslateLoading,
	lastTranslateTargetLang
}: IGetNextFileTabsParams): IFileTabsState => {
	// LEFT
	const leftLanguageExists =
		leftTab === 'original' || translationLanguages.includes(leftTab)

	const nextLeftTab = leftLanguageExists ? leftTab : 'original'

	if (rightTab === null) {
		return {
			leftTab: nextLeftTab,
			rightTab: translationLanguages[0] || null
		}
	}

	// RIGHT
	const rightExists = translationLanguages.includes(rightTab)

	if (rightExists) {
		return {
			leftTab: nextLeftTab,
			rightTab
		}
	}

	const isJustRequestedTarget = lastTranslateTargetLang === rightTab

	if (!isTranslateLoading && !isJustRequestedTarget) {
		return {
			leftTab: nextLeftTab,
			rightTab: translationLanguages[0] || null
		}
	}

	return {
		leftTab: nextLeftTab,
		rightTab
	}
}
